var map = {
	"./1.jpg": "4k8s",
	"./2.jpg": "EUiF",
	"./3.jpg": "Z2o2",
	"./4.jpg": "CW76",
	"./5.jpg": "xcV+",
	"./6.jpg": "22B2",
	"./7.jpg": "7zfH",
	"./8.jpg": "+5cN",
	"./9.jpg": "AUom"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HeJj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/duplo1 ^\.\/.*\.jpg$
// module id = HeJj
// module chunks = 1